import OpenLinkInNewTab from "shared/form/core/link";
import { OrganizationInfoCardProps } from "./types";
import Icon from "assets/icons";
import React from "react";

export default function OrganizationInfoCard(props: OrganizationInfoCardProps) {
  return (
    <div className="view_profile">
      <div className="view_profile_OrgImg">
        {props.organizationInfo?.organizationLogo ? (
          <img src={props.organizationInfo?.organizationLogo} alt="" />
        ) : (
          <div className="view_profile_img_default">
            <Icon.OrgDefaultLogo />
          </div>
        )}
      </div>
      <div className="view_profile_content">
        <span className="view_profile_content_name">
          {props.organizationInfo?.organizationName}
          {props.organizationInfo?.organizationUrl && (
            <OpenLinkInNewTab
              url={props.organizationInfo?.organizationUrl as string}
              title={props.organizationInfo?.organizationName as string}
              label={<Icon.GlobeLines />}
            />
          )}
        </span>
      </div>
    </div>
  );
}
